import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "q-mt-md flex justify-center" }
const _hoisted_2 = {
  class: "q-ma-md",
  style: {"width":"150px"}
}
const _hoisted_3 = {
  class: "q-ma-md",
  style: {"width":"150px"}
}
const _hoisted_4 = {
  class: "absolute-right q-pa-sm",
  style: {"z-index":"1"}
}

import { onBeforeMount, onMounted, ref, watch, computed } from "vue";
  import { useGeolocation } from '@vueuse/core'
  import { Dialog } from "quasar";
  import Calculator from "src/components/budgetcalculator/Calculator.vue";
  import { useDraggable, useMouse  } from '@vueuse/core'
  import authenticationService from "src/services/authentication-service";
  import { useSettingsStore } from "src/stores/settings-store";
  import { useProposalStore } from "src/stores/proposal-store";
  import { useAuthStore } from "src/stores/auth-store";

  import DealerPicker from "src/components/account/DealerPicker.vue";
  import Header from "components/layout/Header.vue";
  import Footer from "components/layout/Footer.vue";
  import { useRoute, useRouter } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

  const route = useRoute();
  const settingsStore = useSettingsStore();
  const proposalStore = useProposalStore();
  const authStore = useAuthStore();

  const isMobile = computed(() => settingsStore.isMobile);

  const el = ref<HTMLElement | null>(null)
  const { x, y, sourceType } = useMouse()
  let { style } = useDraggable(el, {
    initialValue: { x: x.value, y: y.value },
  })
  
  const fullscreen = ref(false);
  const adblockEnabled = ref(false);

  const showCalculator = ref(false);

  onMounted(() => {

    // Check token issue date, force logout if token is older than a certain date
    // Useful when deploying authentication changes
    if (authStore.user && authStore.user.iat) {
      const tokenIssueDate = new Date(authStore.user.iat * 1000);
      const forcedLogoutDate = new Date(2023, 10, 23, 13, 0);
      if (tokenIssueDate < forcedLogoutDate) {
        showDealerSelect.value = false;
        authStore.logout(true);
        setTimeout(() => {
          Dialog.create({
            title: "Update",
            message: "Your Dealer Portal has been updated. You are required to log in again."
          })
        }, 500)
      }
    }

    if(authStore.user && authStore.userId){
      settingsStore.getDealerUserSettings(authStore.userId)
    }

    if (authStore.affiliateUserId) {
      settingsStore.getDealerSettings(authStore.affiliateUserId)
    }

    // Adblock detection
    if (authStore.isYopmail) {
      setTimeout(() => {
        fetch('https://www3.doubleclick.net', {
          method: "HEAD",
          mode: "no-cors",
          cache: "no-store",
        }).then(res => {
          if (res.status === 200) {
            adblockEnabled.value = true;
          }
          else {
            adblockEnabled.value = false;
          }
        }).catch(() => {
          adblockEnabled.value = true;
        });
      }, 2000)
    }

  })

  const showDealerSelect = ref(false);

  watch(showCalculator, () => {
    if (showCalculator.value) {
      style = useDraggable(el, {
        initialValue: { x: x.value, y: y.value },
      }).style
    }
  })

  const footerRef = ref<{ toggleDrawer: () => {} } | null>(null);
  function toggleDrawer() {
    footerRef.value!.toggleDrawer();
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hHh LpR fFf",
    class: _normalizeClass(isMobile.value ? 'full-height' : 'full-height')
  }, {
    default: _withCtx(() => [
      (isMobile.value)
        ? (_openBlock(), _createBlock(Header, {
            key: 0,
            onToggleDrawer: toggleDrawer
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_container, {
        class: _normalizeClass(isMobile.value ? 'constrain full-height' : 'full-height')
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _unref(route).fullPath
          }))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Footer, {
        onSelectDealer: _cache[0] || (_cache[0] = ($event: any) => (showDealerSelect.value = true)),
        ref_key: "footerRef",
        ref: footerRef
      }, null, 512),
      _createVNode(_component_q_dialog, {
        modelValue: adblockEnabled.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((adblockEnabled).value = $event)),
        "full-height": "",
        "full-width": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "full-height full-width" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "flex justify-end" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    round: "",
                    dense: "",
                    flat: "",
                    icon: "mdi-close"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, {
                style: {"max-width":"700px"},
                class: "q-mx-auto"
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-h4 text-center text-primary" }, "AdBlock Detected", -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "q-mt-lg text-body-lg text-center" }, " Using AdBlock prevents CarFinance 247 from collecting vital information which is used to improve your experience, report errors, and helps us unserstand how you are using the Dealer Portal. ", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "q-mt-md text-body-lg text-center" }, " Please disable AdBlock on this site. ", -1)),
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-h6 text-center q-mb-sm" }, "uBlock", -1)),
                      _createVNode(_component_q_img, {
                        src: require('assets/gif/ublock.gif'),
                        width: "150px"
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-h6 text-center q-mb-sm" }, "AdBlock", -1)),
                      _createVNode(_component_q_img, {
                        src: require('assets/gif/adblock.gif'),
                        width: "150px"
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _: 1,
                __: [10,11,12]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", {
        ref_key: "el",
        ref: el,
        style: _normalizeStyle([_unref(style), {"min-width":"400px"}]),
        class: "draggable-popup shadow-2 cursor-move"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_btn, {
            icon: "mdi-close",
            flat: "",
            dense: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showCalculator.value=false))
          })
        ]),
        _createVNode(Calculator, { popout: "" }),
        _createVNode(_component_q_card_section, { class: "flex full-width justify-end q-pt-none" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              outline: "",
              color: "primary",
              class: "brand-button",
              label: "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showCalculator.value=false))
            })
          ]),
          _: 1
        })
      ], 4), [
        [_vShow, showCalculator.value]
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: showDealerSelect.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDealerSelect).value = $event)),
        maximized: isMobile.value,
        persistent: _unref(authStore).selectedDealers ? false : true
      }, {
        default: _withCtx(() => [
          (showDealerSelect.value)
            ? (_openBlock(), _createBlock(DealerPicker, {
                key: 0,
                maximized: fullscreen.value,
                onShow: _cache[4] || (_cache[4] = (val) => showDealerSelect.value = val),
                onFullscreen: _cache[5] || (_cache[5] = (val) => fullscreen.value = val)
              }, null, 8, ["maximized"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "maximized", "persistent"]),
      _createVNode(_component_q_menu, {
        "touch-position": "",
        "context-menu": "",
        target: "#budget-calc-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, {
            dense: "",
            style: {"min-width":"100px"}
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (showCalculator.value = !showCalculator.value))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(showCalculator.value ? 'Close' : 'Open') + " Calculator", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})